import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Algorithm for unlocking any man's heart",
  "description": "",
  "published": "2009-01-30T00:00:00.000Z",
  "redirect_from": ["/blog/algorithm-for-unlocking-any-mans-heart/swizec/11"],
  "categories": "advice, commentary",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the past few days I've been partaking in a rather vibrant forum thread celebrating the male to female differences. It started off with a school mate asking for photos of our female school mates, presumably because he's horny and too lazy to go looking for chicks at the faculty himself. But I decided to make a thread out of it and started trolling, so it quickly grew up to be a lofty six page thread of halfseriousnes and halfmockery of all that is feminism. Most of all, I was later told that it's earned me a slap from a lass I've yet to meet. Guess I'll know when I meet her!`}</p>
    <p>{`Part of the thread was devoted to romance and even though I proposed a purely hypothetical idea of what us male humans like to find romantic, strangely enough many others quite agreed to a point and even stranger, one of the girls seems to have run an experiment on her boyfriend and discovered that my hypothesis holds. Wewt for me!`}</p>
    <p>{`So, if we give extrapolating an algorithm out of the whole ordeal a shot we get something like this ... I should really draw a graph ... hmm let's see if I have a tool for it. `}{`*`}{`consults twitter`}{`*`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/images/collection/54.jpg",
        "alt": "Algorithm for unlocking any man's heart",
        "title": "Algorithm for unlocking any man's heart"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      